import { TransactionsCancelRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useTransactionCancel({ bearer }: { bearer: string }) {
  const [fetching, setFetching] = useState(false);

  async function transactionCancel(params: TransactionsCancelRequest) {
    try {
      setFetching(true);
      const res = await api.postTransactionCancel(params, bearer);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, transactionCancel };
}
